import * as React from 'react';
const SvgLocation = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M10 16.157q2.384-2.084 3.711-4.064 1.329-1.98 1.329-3.49 0-2.195-1.427-3.653T10 3.492 6.387 4.95 4.96 8.603q0 1.51 1.329 3.49 1.327 1.98 3.711 4.064m0 1.044q-.222 0-.414-.074a1.5 1.5 0 0 1-.389-.23 31 31 0 0 1-1.505-1.4 20 20 0 0 1-1.762-1.991 12.8 12.8 0 0 1-1.456-2.368q-.597-1.263-.597-2.535 0-2.551 1.71-4.369T10 2.417q2.683 0 4.403 1.817 1.72 1.818 1.72 4.369 0 1.272-.608 2.542t-1.45 2.378a17 17 0 0 1-1.748 1.981 35 35 0 0 1-1.506 1.386 1.5 1.5 0 0 1-.39.233q-.195.078-.421.078m.002-7.313q.559 0 .948-.39.39-.391.39-.951t-.391-.949-.95-.39-.95.391q-.389.392-.389.95 0 .56.391.95.39.39.95.389'
            />
        </g>
    </svg>
);
export default SvgLocation;
